import { API } from "@/api/constants";

export class Captcha {
  constructor() {
    this.recaptchaScriptId = "__RECAPTCHA_SCRIPT";
    this.recaptchaKey = API.RECAPTCHA_KEY;
    this.loadCallbackFnName = "recaptchaApiLoaded";
    this.errorCallbackFnName = "recaptchaApiLoadError";
    this.isLoaded = false;
  }

  static getInstance() {
    if (!Captcha.instance) {
      Captcha.instance = new Captcha();
    }

    return Captcha.instance;
  }

  init() {
    if (!this.checkLoad()) {
      window[this.loadCallbackFnName] = this.onLoad.bind(this);
      window[this.errorCallbackFnName] = this.onError.bind(this);
      const scriptElement = document.createElement("script");
      scriptElement.id = this.recaptchaScriptId;
      const scriptSource = new URL(
        "https://www.recaptcha.net/recaptcha/api.js",
      );
      scriptSource.search = new URLSearchParams({
        onload: this.loadCallbackFnName,
        render: this.recaptchaKey,
        onerror: this.errorCallbackFnName,
      }).toString();
      scriptElement.src = scriptSource.toString();
      scriptElement.async = true;
      this.recaptchaScript = document.head.appendChild(scriptElement);
    }
  }

  onLoad() {
    this.recaptcha = window?.grecaptcha;
    if (!this.recaptcha) {
      throw new Error(
        "failed load captcha service, check env variable VUE_APP_RECAPTCHA_KEY",
      );
    }
    this.isLoaded = true;
  }

  destroy() {
    document.head.removeChild(this.recaptchaScript);
    const grecaptchaBadge =
      document.getElementsByClassName("grecaptcha-badge")[0];
    grecaptchaBadge.parentNode.removeChild(grecaptchaBadge);
    delete window.grecaptcha;
  }

  checkLoad() {
    return "grecaptcha" in window && "render" in window.grecaptcha;
  }

  check(actionName = "checkCaptcha") {
    return new Promise((resolve, reject) => {
      let isRecapthaReady = false;
      const readyTimer = setTimeout(() => {
        if (!isRecapthaReady) {
          return reject(new Error("grecaptcha is unavailable"));
        }
      }, 3000);
      this.recaptcha.ready(() => {
        isRecapthaReady = true;
        clearTimeout(readyTimer);
        this.recaptcha
          .execute(this.recaptchaKey, {
            action: actionName,
          })
          .then((response) => resolve(response))
          .catch((err) => {
            return reject(err);
          });
      });
    });
  }

  onError() {
    console.log("onError");
    console.log(...arguments);
  }
}

export const Index = Captcha.getInstance();
export default Index;
